export const LOCATION_PATCH_TYPES = {
    CORE: "CORE",
    ATTRIBUTES: "ATTRIBUTES",
    ALL: "ALL"
};